const PR_SFX_KINDS = [
  "click",
  "hover",
  "dragStart",
  "dragMove",
  "drop",
  "scroll",
  "select",
  "toggle",
  "expand",
  "collapse",
  "key",
  "marquee"
];
const PR_SFX_SOUNDS = [
  "off",
  "blip",
  "ping",
  "chirp",
  "thud",
  "scrape",
  "tick",
  "tickSoft",
  "sweepUp",
  "sweepDown",
  "type",
  "scan",
  "buzz",
  "pop",
  "saber",
  "blaster",
  "holoBeep",
  "forceWhoosh",
  "lcarsBeep",
  "transporter",
  "commChirp",
  "redAlert"
];
const PR_SFX_KIND_LABEL_KEYS = {
  click: "prSfxActionClick",
  hover: "prSfxActionHover",
  dragStart: "prSfxActionDragStart",
  dragMove: "prSfxActionDragMove",
  drop: "prSfxActionDrop",
  scroll: "prSfxActionScroll",
  select: "prSfxActionSelect",
  toggle: "prSfxActionToggle",
  expand: "prSfxActionExpand",
  collapse: "prSfxActionCollapse",
  key: "prSfxActionKey",
  marquee: "prSfxActionMarquee"
};
const PR_SFX_SOUND_LABEL_KEYS = {
  off: "prSfxSoundOff",
  blip: "prSfxSoundBlip",
  ping: "prSfxSoundPing",
  chirp: "prSfxSoundChirp",
  thud: "prSfxSoundThud",
  scrape: "prSfxSoundScrape",
  tick: "prSfxSoundTick",
  tickSoft: "prSfxSoundTickSoft",
  sweepUp: "prSfxSoundSweepUp",
  sweepDown: "prSfxSoundSweepDown",
  type: "prSfxSoundType",
  scan: "prSfxSoundScan",
  buzz: "prSfxSoundBuzz",
  pop: "prSfxSoundPop",
  saber: "prSfxSoundSaber",
  blaster: "prSfxSoundBlaster",
  holoBeep: "prSfxSoundHoloBeep",
  forceWhoosh: "prSfxSoundForceWhoosh",
  lcarsBeep: "prSfxSoundLcarsBeep",
  transporter: "prSfxSoundTransporter",
  commChirp: "prSfxSoundCommChirp",
  redAlert: "prSfxSoundRedAlert"
};
const SFX_ENABLED_KEY = "mail-aid:prSfxEnabled.v1";
const SFX_ACTIONS_KEY = "mail-aid:prSfxActions.v1";
const SFX_SOUND_MAP_KEY = "mail-aid:prSfxSoundMap.v1";
const SFX_SOUND_MAPS_BY_DESIGN_KEY = "mail-aid:prSfxSoundMapsByDesign.v1";
const SFX_OUTPUT_KEY = "mail-aid:prSfxOutputDevice.v1";
const SFX_VOLUME_KEY = "mail-aid:prSfxVolume.v1";
const SFX_AMBIENT_KEY = "mail-aid:prSfxAmbient.v1";
const PR_SFX_VOLUME_MIN = 0;
const PR_SFX_VOLUME_MAX = 3;
const PR_SFX_VOLUME_DEFAULT = 1;
const PROFILES = {
  "pr-gipsy": {
    click: 880,
    drag: 220,
    drop: 160,
    scroll: 640,
    select: 980
  },
  "pr-cherno": {
    click: 520,
    drag: 140,
    drop: 90,
    scroll: 380,
    select: 600
  },
  "pr-kaiju": {
    click: 720,
    drag: 180,
    drop: 110,
    scroll: 520,
    select: 840
  },
  "pr-shatterdome": {
    click: 660,
    drag: 200,
    drop: 130,
    scroll: 480,
    select: 740
  },
  "sw-rebel": {
    click: 740,
    drag: 190,
    drop: 120,
    scroll: 560,
    select: 900
  },
  "sw-empire": {
    click: 420,
    drag: 110,
    drop: 80,
    scroll: 300,
    select: 520
  },
  "sw-jedi": {
    click: 980,
    drag: 240,
    drop: 150,
    scroll: 700,
    select: 1100
  },
  "sw-sith": {
    click: 380,
    drag: 100,
    drop: 70,
    scroll: 280,
    select: 480
  },
  "sw-mandalorian": {
    click: 620,
    drag: 170,
    drop: 115,
    scroll: 460,
    select: 760
  },
  "st-tng": {
    click: 820,
    drag: 210,
    drop: 140,
    scroll: 600,
    select: 940
  },
  "st-tos": {
    click: 700,
    drag: 180,
    drop: 125,
    scroll: 520,
    select: 860
  },
  "st-ds9": {
    click: 640,
    drag: 160,
    drop: 110,
    scroll: 480,
    select: 780
  },
  "st-voyager": {
    click: 780,
    drag: 200,
    drop: 135,
    scroll: 580,
    select: 900
  },
  "st-discovery": {
    click: 860,
    drag: 220,
    drop: 145,
    scroll: 620,
    select: 980
  }
};
function defaultSoundMapForAppearance(id) {
  if (id.startsWith("sw-")) {
    return {
      click: "blaster",
      hover: "holoBeep",
      dragStart: "forceWhoosh",
      dragMove: "tickSoft",
      drop: "saber",
      scroll: "tick",
      select: "holoBeep",
      toggle: "blaster",
      expand: "forceWhoosh",
      collapse: "saber",
      key: "type",
      marquee: "scan"
    };
  }
  if (id.startsWith("st-")) {
    return {
      click: "lcarsBeep",
      hover: "commChirp",
      dragStart: "transporter",
      dragMove: "tickSoft",
      drop: "lcarsBeep",
      scroll: "tick",
      select: "commChirp",
      toggle: "lcarsBeep",
      expand: "transporter",
      collapse: "redAlert",
      key: "type",
      marquee: "scan"
    };
  }
  return {
    click: "blip",
    hover: "tickSoft",
    dragStart: "scrape",
    dragMove: "tick",
    drop: "thud",
    scroll: "tick",
    select: "chirp",
    toggle: "blip",
    expand: "sweepUp",
    collapse: "sweepDown",
    key: "type",
    marquee: "scan"
  };
}
function defaultSoundMap() {
  return defaultSoundMapForAppearance(appearance);
}
function isSoundId(v) {
  return typeof v === "string" && PR_SFX_SOUNDS.includes(v);
}
function normalizeSoundMap(raw, designId = appearance) {
  const base = defaultSoundMapForAppearance(designId);
  if (!raw || typeof raw !== "object") return base;
  const obj = raw;
  for (const kind of PR_SFX_KINDS) {
    if (isSoundId(obj[kind])) base[kind] = obj[kind];
  }
  return base;
}
function migrateFromActionPrefs(raw, designId = appearance) {
  if (!raw || typeof raw !== "object") return null;
  const obj = raw;
  let sawBool = false;
  const base = defaultSoundMapForAppearance(designId);
  for (const kind of PR_SFX_KINDS) {
    if (typeof obj[kind] === "boolean") {
      sawBool = true;
      base[kind] = obj[kind]
        ? defaultSoundMapForAppearance(designId)[kind]
        : "off";
    }
  }
  return sawBool ? base : null;
}
let ctx = null;
let masterGain = null;
let ambientOsc = null;
let ambientLfo = null;
let appearance = "curriculum";
let enabled = readPrSfxEnabled();
let ambientEnabled = readPrSfxAmbient();
let soundMap = readPrSfxSoundMap();
let outputDeviceId = readPrSfxOutputDeviceId();
let volume = readPrSfxVolume();
let lastScrollAt = 0;
let lastDragMoveAt = 0;
let lastClickAt = 0;
let lastKeyAt = 0;
let lastMarqueeAt = 0;
let lastHoverAt = 0;
function isPacificRimAppearance(id) {
  return id.startsWith("pr-");
}
function isSfxAppearance(id) {
  return id.startsWith("pr-") || id.startsWith("sw-") || id.startsWith("st-");
}
function readPrSfxAmbient() {
  try {
    const raw = localStorage.getItem(SFX_AMBIENT_KEY);
    if (raw == null) return false;
    return raw === "1" || raw === "true";
  } catch {
    return false;
  }
}
function writePrSfxAmbient(next) {
  ambientEnabled = next;
  try {
    localStorage.setItem(SFX_AMBIENT_KEY, next ? "1" : "0");
  } catch {
  }
  syncAmbientHum();
}
function readPrSfxEnabled() {
  try {
    const raw = localStorage.getItem(SFX_ENABLED_KEY);
    if (raw == null) return true;
    return raw === "1" || raw === "true";
  } catch {
    return true;
  }
}
function writePrSfxEnabled(next) {
  enabled = next;
  try {
    localStorage.setItem(SFX_ENABLED_KEY, next ? "1" : "0");
  } catch {
  }
  syncAmbientHum();
}
function persistMapsByDesign(maps) {
  try {
    localStorage.setItem(SFX_SOUND_MAPS_BY_DESIGN_KEY, JSON.stringify(maps));
    if (isSfxAppearance(appearance) && maps[appearance]) {
      localStorage.setItem(
        SFX_SOUND_MAP_KEY,
        JSON.stringify(maps[appearance])
      );
    }
  } catch {
  }
}
function readPrSfxSoundMapsByDesign() {
  try {
    const rawMaps = localStorage.getItem(SFX_SOUND_MAPS_BY_DESIGN_KEY);
    if (rawMaps) {
      const parsed = JSON.parse(rawMaps);
      if (parsed && typeof parsed === "object") {
        const out = {};
        for (const [designId, map] of Object.entries(parsed)) {
          out[designId] = normalizeSoundMap(map, designId);
        }
        return out;
      }
    }
    const maps = {};
    const rawMap = localStorage.getItem(SFX_SOUND_MAP_KEY);
    if (rawMap) {
      const designId = isSfxAppearance(appearance) ? appearance : "pr-gipsy";
      maps[designId] = normalizeSoundMap(JSON.parse(rawMap), designId);
      persistMapsByDesign(maps);
      return maps;
    }
    const legacy = localStorage.getItem(SFX_ACTIONS_KEY);
    if (legacy) {
      const designId = isSfxAppearance(appearance) ? appearance : "pr-gipsy";
      const migrated = migrateFromActionPrefs(JSON.parse(legacy), designId);
      if (migrated) {
        maps[designId] = migrated;
        persistMapsByDesign(maps);
        return maps;
      }
    }
    return {};
  } catch {
    return {};
  }
}
function readPrSfxSoundMap(designId = appearance) {
  const maps = readPrSfxSoundMapsByDesign();
  if (maps[designId]) return normalizeSoundMap(maps[designId], designId);
  return defaultSoundMapForAppearance(designId);
}
function writePrSfxSoundMap(next, designId = appearance) {
  const normalized = normalizeSoundMap(next, designId);
  if (designId === appearance) soundMap = normalized;
  const maps = readPrSfxSoundMapsByDesign();
  maps[designId] = normalized;
  persistMapsByDesign(maps);
}
function writePrSfxTriggerSound(kind, sound, designId = appearance) {
  writePrSfxSoundMap({ ...readPrSfxSoundMap(designId), [kind]: sound }, designId);
}
function readPrSfxActionPrefs() {
  const map = readPrSfxSoundMap();
  const prefs = {};
  for (const kind of PR_SFX_KINDS) {
    prefs[kind] = map[kind] !== "off";
  }
  return prefs;
}
function writePrSfxActionPrefs(next) {
  const map = { ...soundMap };
  for (const kind of PR_SFX_KINDS) {
    map[kind] = next[kind] ? defaultSoundMap()[kind] : "off";
  }
  writePrSfxSoundMap(map);
}
function writePrSfxActionEnabled(kind, on) {
  writePrSfxTriggerSound(kind, on ? defaultSoundMap()[kind] : "off");
}
function readPrSfxOutputDeviceId() {
  try {
    return localStorage.getItem(SFX_OUTPUT_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}
function writePrSfxOutputDeviceId(deviceId) {
  outputDeviceId = deviceId.trim();
  try {
    if (outputDeviceId) localStorage.setItem(SFX_OUTPUT_KEY, outputDeviceId);
    else localStorage.removeItem(SFX_OUTPUT_KEY);
  } catch {
  }
  void applyOutputDevice();
}
function clampPrSfxVolume(v) {
  if (!Number.isFinite(v)) return PR_SFX_VOLUME_DEFAULT;
  return Math.min(
    PR_SFX_VOLUME_MAX,
    Math.max(PR_SFX_VOLUME_MIN, Math.round(v * 100) / 100)
  );
}
function readPrSfxVolume() {
  try {
    const raw = localStorage.getItem(SFX_VOLUME_KEY);
    if (raw == null) return PR_SFX_VOLUME_DEFAULT;
    return clampPrSfxVolume(Number(raw));
  } catch {
    return PR_SFX_VOLUME_DEFAULT;
  }
}
function writePrSfxVolume(next) {
  volume = clampPrSfxVolume(next);
  try {
    localStorage.setItem(SFX_VOLUME_KEY, String(volume));
  } catch {
  }
  if (masterGain) {
    masterGain.gain.value = volume;
  }
}
function setPrSfxAppearance(id) {
  appearance = id;
  soundMap = readPrSfxSoundMap(id);
  syncAmbientHum();
}
/** Task-Cloud-Prefs anwenden (Mail: nur lesen). */
function applyUserUiSfxPrefs(prefs) {
  enabled = prefs.enabled;
  ambientEnabled = prefs.ambient;
  volume = clampPrSfxVolume(prefs.volume);
  try {
    localStorage.setItem(SFX_ENABLED_KEY, prefs.enabled ? "1" : "0");
    localStorage.setItem(SFX_AMBIENT_KEY, prefs.ambient ? "1" : "0");
    localStorage.setItem(SFX_VOLUME_KEY, String(volume));
  } catch {
  }
  const maps = {};
  for (const [designId, map] of Object.entries(prefs.soundMapsByDesign ?? {})) {
    maps[designId] = normalizeSoundMap(map, designId);
  }
  persistMapsByDesign(maps);
  soundMap = readPrSfxSoundMap(appearance);
  if (masterGain) masterGain.gain.value = volume;
  syncAmbientHum();
}
function ensureCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) {
    ctx = new AC();
    masterGain = null;
  }
  if (ctx.state === "suspended") {
    void ctx.resume();
  }
  return ctx;
}
function ensureMasterGain(audio) {
  if (!masterGain || masterGain.context !== audio) {
    masterGain = audio.createGain();
    masterGain.gain.value = volume;
    masterGain.connect(audio.destination);
  }
  return masterGain;
}
async function applyOutputDevice() {
  const audio = ensureCtx();
  if (!audio?.setSinkId) return;
  try {
    await audio.setSinkId(outputDeviceId || "");
  } catch {
  }
}
function unlockPrSfx() {
  ensureCtx();
  void applyOutputDevice();
  syncAmbientHum();
}
function stopAmbientHum() {
  try {
    ambientOsc?.stop();
  } catch {
  }
  try {
    ambientLfo?.stop();
  } catch {
  }
  ambientOsc = null;
  ambientLfo = null;
}
function startAmbientHum() {
  const audio = ensureCtx();
  if (!audio) return;
  stopAmbientHum();
  const master = ensureMasterGain(audio);
  const now = audio.currentTime;
  const filter = audio.createBiquadFilter();
  filter.type = "lowpass";
  const baseFreq = appearance.startsWith("st-") ? 220 : appearance.startsWith("sw-") ? 90 : 140;
  filter.frequency.value = baseFreq * 2.2;
  filter.Q.value = 0.8;
  const gain = audio.createGain();
  gain.gain.value = 1e-4;
  const osc = audio.createOscillator();
  osc.type = appearance.startsWith("sw-") ? "sawtooth" : "sine";
  osc.frequency.value = baseFreq;
  const lfo = audio.createOscillator();
  lfo.type = "sine";
  lfo.frequency.value = appearance.startsWith("st-") ? 0.18 : 0.12;
  const lfoGain = audio.createGain();
  lfoGain.gain.value = baseFreq * 0.08;
  lfo.connect(lfoGain);
  lfoGain.connect(osc.frequency);
  osc.connect(filter);
  filter.connect(gain);
  gain.connect(master);
  osc.start(now);
  lfo.start(now);
  gain.gain.exponentialRampToValueAtTime(0.012, now + 1.2);
  ambientOsc = osc;
  ambientLfo = lfo;
}
function syncAmbientHum() {
  const want = ambientEnabled && enabled && isSfxAppearance(appearance) && !!ctx;
  if (!want) {
    stopAmbientHum();
    return;
  }
  if (!ambientOsc) startAmbientHum();
}
function supportsPrSfxOutputSelect() {
  if (typeof window === "undefined") return false;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return false;
  return typeof AC.prototype.setSinkId === "function";
}
async function listPrSfxOutputDevices(opts) {
  if (!navigator.mediaDevices?.enumerateDevices) return [];
  try {
    let devices = await navigator.mediaDevices.enumerateDevices();
    const outputs = devices.filter((d) => d.kind === "audiooutput");
    if (opts?.requestLabels && outputs.some((d) => !d.label.trim())) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true
        });
        stream.getTracks().forEach((t) => t.stop());
        devices = await navigator.mediaDevices.enumerateDevices();
      } catch {
      }
    }
    return devices.filter((d) => d.kind === "audiooutput").map((d, i) => ({
      deviceId: d.deviceId,
      label: d.label.trim() || `Audio ${i + 1}`
    }));
  } catch {
    return [];
  }
}
async function prSfxOutputLabelsNeedPermission() {
  if (!navigator.mediaDevices?.enumerateDevices) return false;
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const outputs = devices.filter((d) => d.kind === "audiooutput");
    if (outputs.length === 0) return false;
    return outputs.some((d) => !d.label.trim());
  } catch {
    return false;
  }
}
function profile() {
  return PROFILES[appearance] ?? PROFILES["pr-gipsy"];
}
function tone(frequency, opts = {}) {
  const audio = ensureCtx();
  if (!audio) return;
  const now = audio.currentTime;
  const duration = opts.duration ?? 0.06;
  const gainPeak = opts.gain ?? 0.045;
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  const filter = audio.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = opts.filterFreq ?? 2400;
  osc.type = opts.type ?? "square";
  osc.frequency.setValueAtTime(frequency, now);
  if (opts.slideTo != null) {
    osc.frequency.exponentialRampToValueAtTime(
      Math.max(40, opts.slideTo),
      now + duration
    );
  }
  gain.gain.setValueAtTime(1e-4, now);
  gain.gain.exponentialRampToValueAtTime(gainPeak, now + 8e-3);
  gain.gain.exponentialRampToValueAtTime(1e-4, now + duration);
  osc.connect(filter);
  filter.connect(gain);
  gain.connect(ensureMasterGain(audio));
  osc.start(now);
  osc.stop(now + duration + 0.02);
}
function noiseBurst(opts = {}) {
  const audio = ensureCtx();
  if (!audio) return;
  const duration = opts.duration ?? 0.04;
  const frames = Math.max(1, Math.floor(audio.sampleRate * duration));
  const buffer = audio.createBuffer(1, frames, audio.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < frames; i++) {
    data[i] = (Math.random() * 2 - 1) * (1 - i / frames);
  }
  const src = audio.createBufferSource();
  src.buffer = buffer;
  const filter = audio.createBiquadFilter();
  filter.type = "bandpass";
  filter.frequency.value = 1800;
  filter.Q.value = 0.7;
  const gain = audio.createGain();
  const now = audio.currentTime;
  const peak = opts.gain ?? 0.03;
  gain.gain.setValueAtTime(1e-4, now);
  gain.gain.exponentialRampToValueAtTime(peak, now + 5e-3);
  gain.gain.exponentialRampToValueAtTime(1e-4, now + duration);
  src.connect(filter);
  filter.connect(gain);
  gain.connect(ensureMasterGain(audio));
  src.start(now);
  src.stop(now + duration + 0.02);
}
function playSoundPatch(sound) {
  if (sound === "off") return;
  const p = profile();
  switch (sound) {
    case "blip":
      tone(p.click, { duration: 0.045, type: "square", gain: 0.038 });
      tone(p.click * 1.5, {
        duration: 0.03,
        type: "triangle",
        gain: 0.02,
        filterFreq: 3200
      });
      break;
    case "ping":
      tone(p.click * 1.2, {
        duration: 0.09,
        type: "sine",
        gain: 0.04,
        slideTo: p.click * 1.8,
        filterFreq: 4e3
      });
      break;
    case "chirp":
      tone(p.select, { duration: 0.08, type: "sawtooth", gain: 0.035 });
      tone(p.select * 1.33, {
        duration: 0.1,
        type: "triangle",
        gain: 0.022,
        slideTo: p.select * 1.6
      });
      break;
    case "thud":
      noiseBurst({ duration: 0.05, gain: 0.035 });
      tone(p.drop, {
        duration: 0.12,
        type: "square",
        gain: 0.042,
        slideTo: p.drop * 0.55,
        filterFreq: 800
      });
      break;
    case "scrape":
      noiseBurst({ duration: 0.04, gain: 0.04 });
      tone(p.drag, {
        duration: 0.1,
        type: "sawtooth",
        gain: 0.055,
        slideTo: p.drag * 0.7,
        filterFreq: 1100
      });
      break;
    case "tick":
      tone(p.scroll, {
        duration: 0.028,
        type: "square",
        gain: 0.032,
        filterFreq: 2200
      });
      break;
    case "tickSoft":
      tone(p.drag * 1.25, {
        duration: 0.035,
        type: "triangle",
        gain: 0.038,
        filterFreq: 1400
      });
      break;
    case "sweepUp":
      tone(p.select * 0.72, {
        duration: 0.07,
        type: "sawtooth",
        gain: 0.03,
        slideTo: p.select * 1.15,
        filterFreq: 2600
      });
      tone(p.click * 0.9, {
        duration: 0.04,
        type: "triangle",
        gain: 0.018,
        filterFreq: 3e3
      });
      break;
    case "sweepDown":
      tone(p.select * 1.05, {
        duration: 0.08,
        type: "sawtooth",
        gain: 0.028,
        slideTo: p.select * 0.55,
        filterFreq: 1800
      });
      noiseBurst({ duration: 0.025, gain: 0.016 });
      break;
    case "type":
      tone(p.click * 1.35, {
        duration: 0.028,
        type: "square",
        gain: 0.022,
        filterFreq: 3600
      });
      break;
    case "scan":
      tone(p.scroll * 1.1, {
        duration: 0.03,
        type: "triangle",
        gain: 0.018,
        filterFreq: 2800
      });
      tone(p.select * 0.85, {
        duration: 0.045,
        type: "square",
        gain: 0.012,
        slideTo: p.select * 1.05,
        filterFreq: 3200
      });
      break;
    case "buzz":
      tone(p.drag * 1.4, {
        duration: 0.07,
        type: "sawtooth",
        gain: 0.032,
        filterFreq: 1200
      });
      tone(p.drag * 2.1, {
        duration: 0.05,
        type: "square",
        gain: 0.018,
        filterFreq: 1600
      });
      break;
    case "pop":
      tone(p.click * 0.7, {
        duration: 0.05,
        type: "sine",
        gain: 0.045,
        slideTo: p.click * 0.35,
        filterFreq: 1800
      });
      noiseBurst({ duration: 0.02, gain: 0.02 });
      break;
    case "saber":
      noiseBurst({ duration: 0.08, gain: 0.028 });
      tone(p.drag * 0.9, {
        duration: 0.16,
        type: "sawtooth",
        gain: 0.04,
        slideTo: p.drag * 1.35,
        filterFreq: 900
      });
      tone(p.click * 0.55, {
        duration: 0.12,
        type: "square",
        gain: 0.018,
        filterFreq: 1400
      });
      break;
    case "blaster":
      tone(p.click * 1.1, {
        duration: 0.07,
        type: "square",
        gain: 0.05,
        slideTo: p.click * 0.35,
        filterFreq: 2800
      });
      noiseBurst({ duration: 0.035, gain: 0.03 });
      break;
    case "holoBeep":
      tone(p.select * 1.05, {
        duration: 0.05,
        type: "sine",
        gain: 0.028,
        filterFreq: 3600
      });
      tone(p.select * 1.55, {
        duration: 0.04,
        type: "triangle",
        gain: 0.016,
        filterFreq: 4200
      });
      break;
    case "forceWhoosh":
      noiseBurst({ duration: 0.1, gain: 0.035 });
      tone(p.drag * 1.2, {
        duration: 0.14,
        type: "triangle",
        gain: 0.03,
        slideTo: p.drag * 0.45,
        filterFreq: 1e3
      });
      break;
    case "lcarsBeep":
      tone(p.click, {
        duration: 0.04,
        type: "square",
        gain: 0.032,
        filterFreq: 3e3
      });
      tone(p.click * 1.25, {
        duration: 0.055,
        type: "sine",
        gain: 0.024,
        slideTo: p.click * 1.5,
        filterFreq: 3800
      });
      break;
    case "transporter":
      tone(p.select * 0.8, {
        duration: 0.12,
        type: "sawtooth",
        gain: 0.026,
        slideTo: p.select * 1.4,
        filterFreq: 2400
      });
      tone(p.select * 1.2, {
        duration: 0.1,
        type: "triangle",
        gain: 0.018,
        slideTo: p.select * 0.7,
        filterFreq: 2e3
      });
      noiseBurst({ duration: 0.05, gain: 0.016 });
      break;
    case "commChirp":
      tone(p.select * 1.1, {
        duration: 0.035,
        type: "sine",
        gain: 0.03,
        slideTo: p.select * 1.45,
        filterFreq: 4e3
      });
      tone(p.select * 0.95, {
        duration: 0.03,
        type: "triangle",
        gain: 0.02,
        filterFreq: 3200
      });
      break;
    case "redAlert":
      tone(p.click * 0.85, {
        duration: 0.09,
        type: "square",
        gain: 0.04,
        slideTo: p.click * 1.2,
        filterFreq: 1600
      });
      tone(p.click * 0.7, {
        duration: 0.09,
        type: "sawtooth",
        gain: 0.028,
        slideTo: p.click * 0.5,
        filterFreq: 1200
      });
      break;
    default:
      break;
  }
}
function allowTriggerThrottle(kind, force) {
  if (force) return true;
  const now = performance.now();
  switch (kind) {
    case "click":
    case "toggle":
      if (now - lastClickAt < 40) return false;
      lastClickAt = now;
      return true;
    case "hover":
      if (now - lastHoverAt < 140) return false;
      lastHoverAt = now;
      return true;
    case "dragMove":
      if (now - lastDragMoveAt < 75) return false;
      lastDragMoveAt = now;
      return true;
    case "scroll":
      if (now - lastScrollAt < 70) return false;
      lastScrollAt = now;
      return true;
    case "key":
      if (now - lastKeyAt < 28) return false;
      lastKeyAt = now;
      return true;
    case "marquee":
      if (now - lastMarqueeAt < 70) return false;
      lastMarqueeAt = now;
      return true;
    default:
      return true;
  }
}
function playPrSfx(kind, opts) {
  const force = Boolean(opts?.force);
  if (!force) {
    if (!enabled || !isSfxAppearance(appearance)) return;
  }
  const sound = soundMap[kind] ?? defaultSoundMap()[kind];
  if (sound === "off") return;
  if (!allowTriggerThrottle(kind, force)) return;
  unlockPrSfx();
  playSoundPatch(sound);
}
function previewPrSfxSound(sound) {
  if (sound === "off") return;
  unlockPrSfx();
  playSoundPatch(sound);
}
function previewPrSfx(kind) {
  unlockPrSfx();
  playPrSfx(kind, { force: true });
}
export {
  PR_SFX_KINDS,
  PR_SFX_KIND_LABEL_KEYS,
  PR_SFX_SOUNDS,
  PR_SFX_SOUND_LABEL_KEYS,
  PR_SFX_VOLUME_DEFAULT,
  PR_SFX_VOLUME_MAX,
  PR_SFX_VOLUME_MIN,
  applyUserUiSfxPrefs,
  clampPrSfxVolume,
  isPacificRimAppearance,
  isSfxAppearance,
  listPrSfxOutputDevices,
  playPrSfx,
  prSfxOutputLabelsNeedPermission,
  previewPrSfx,
  previewPrSfxSound,
  readPrSfxActionPrefs,
  readPrSfxAmbient,
  readPrSfxEnabled,
  readPrSfxOutputDeviceId,
  readPrSfxSoundMap,
  readPrSfxVolume,
  setPrSfxAppearance,
  supportsPrSfxOutputSelect,
  syncAmbientHum,
  unlockPrSfx,
  writePrSfxActionEnabled,
  writePrSfxActionPrefs,
  writePrSfxAmbient,
  writePrSfxEnabled,
  writePrSfxOutputDeviceId,
  writePrSfxSoundMap,
  writePrSfxTriggerSound,
  writePrSfxVolume
};

